"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transmitToModel = exports.unbindModel = exports.bindModel = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _dataModel = _interopRequireDefault(require("../../common/backbone/dataModel"));

var _dataCollection = _interopRequireDefault(require("../../common/backbone/dataCollection"));

var _INumber = _interopRequireDefault(require("../../common/iObjects/INumber"));

var _IDate = _interopRequireDefault(require("../../common/iObjects/IDate"));

var _IPeriod = _interopRequireDefault(require("../../common/iObjects/IPeriod"));

var _IAccount = _interopRequireDefault(require("../../common/iObjects/IAccount"));

var _ICurrency = _interopRequireDefault(require("../../common/iObjects/ICurrency"));

var _IPhone = _interopRequireDefault(require("../../common/iObjects/IPhone"));

var _IOTP = _interopRequireDefault(require("../../common/iObjects/IOTP"));

var _ICVV = _interopRequireDefault(require("../../common/iObjects/ICVV"));

var _IEmail = _interopRequireDefault(require("../../common/iObjects/IEmail"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint one-var: off */
var _byContext = {};
var _byStorage = {};
var _byDataMapper = {};

var _getContextId = function _getContextId(context) {
  return Object.keys(_byContext).find(function (key) {
    return _byContext[key] === context;
  });
};

var registerContext = function registerContext(context) {
  if (!Object.values(_byContext).includes(context)) {
    var id = (0, _uniqueId["default"])('context_');
    _byContext[id] = context;
    _byStorage[id] = null;
  }

  return context;
};

var unregisterContext = function unregisterContext(context) {
  var id = _getContextId(context);

  if (id) {
    delete _byContext[id];
  }
};

var getStorage = function getStorage(context) {
  var id = _getContextId(context);

  return id ? _byStorage[id] : null;
};

var setStorage = function setStorage(context, storage) {
  var id = _getContextId(context);

  if (id) {
    _byStorage[id] = storage;
  }
};

var unsetStorage = function unsetStorage(context) {
  var id = _getContextId(context);

  if (id) {
    _byStorage[id] = null;
  }
};

var getDataMapper = function getDataMapper(context) {
  var id = _getContextId(context);

  return id ? _byDataMapper[id] : null;
};

var setDataMapper = function setDataMapper(context, mapper) {
  var id = _getContextId(context);

  if (id) {
    _byDataMapper[id] = mapper;
  }
};

var unsetDataMapper = function unsetDataMapper(context) {
  var id = _getContextId(context);

  if (id) {
    _byDataMapper[id] = null;
  }
};

var _mapDataToModel = function _mapDataToModel(data, mapper) {
  if (typeof mapper === 'string' && data[mapper] !== undefined) {
    return (0, _defineProperty2["default"])({}, mapper, data[mapper]);
  } else if (mapper instanceof Array) {
    var result = {};
    mapper.forEach(function (attribute) {
      if (data[attribute] !== undefined) {
        result[attribute] = data[attribute];
      }
    });
    return result;
  } else if (typeof mapper === 'function') {
    return mapper(data);
  }
};

var _serializeData = function _serializeData(raw) {
  var json = {},
      keys = Object.keys(raw);
  var value;
  keys.forEach(function (key) {
    value = raw[key];

    if (value instanceof _dataCollection["default"] || value instanceof _dataModel["default"]) {
      json[key] = value.toJSON();
    } else if (value instanceof _INumber["default"]) {
      json[key] = value.toFloat();
    } else if (value instanceof _IDate["default"] || value instanceof _IPeriod["default"] || value instanceof _IAccount["default"] || value instanceof _ICurrency["default"] || value instanceof _IPhone["default"] || value instanceof _IOTP["default"] || value instanceof _ICVV["default"] || value instanceof _IEmail["default"]) {
      json[key] = value.toString();
    } else {
      json[key] = value;
    }
  });
  return json;
};
/* eslint camelcase: "off" */


var _getDataBindOptions = function _getDataBindOptions(mapper, context) {
  if (typeof mapper === 'function') {
    var getFromModel = function getFromModel(model) {
      return mapper(model);
    };

    return {
      mapToState: function mapToState(model) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if ((options === null || options === void 0 ? void 0 : options.__data_bind_source_context) !== context) {
          context.setState(getFromModel(model), null, {
            silent: true
          });
        }
      },
      getFromModel: getFromModel
    }; // map single attribute to state
  } else if (typeof mapper === 'string') {
    var _getFromModel = function _getFromModel(model) {
      return _serializeData((0, _defineProperty2["default"])({}, mapper, model.get(mapper)));
    };

    return {
      name: mapper,
      mapToState: function mapToState(model, changed, options) {
        if ((options === null || options === void 0 ? void 0 : options.__data_bind_source_context) !== context) {
          context.setState(_getFromModel(model), null, {
            silent: true
          });
        }
      },
      getFromModel: _getFromModel
    }; // map list of attributes to state
  } else if (Array.isArray(mapper)) {
    return mapper.map(function (name) {
      var getFromModel = function getFromModel(model) {
        return _serializeData((0, _defineProperty2["default"])({}, name, model.get(name)));
      };

      return {
        name: name,
        mapToState: function mapToState(model, changed, options) {
          if ((options === null || options === void 0 ? void 0 : options.__data_bind_source_context) !== context) {
            context.setState(getFromModel(model), null, {
              silent: true
            });
          }
        },
        getFromModel: getFromModel
      };
    });
  } else {
    return {};
  }
};

var _bindStorage = function _bindStorage(context, storage, callback, name) {
  if (typeof callback === 'function') {
    if (name) {
      context.listenTo(storage, "change:".concat(name), callback);
    } else {
      context.listenTo(storage, 'change', callback);
    }
  }
};

var _bind = function _bind(context, storage, mapModelToState) {
  var bindOptions = _getDataBindOptions(mapModelToState, context);

  if (Array.isArray(bindOptions)) {
    var initialState = {};
    bindOptions.forEach(function (_ref2) {
      var name = _ref2.name,
          mapToState = _ref2.mapToState,
          getFromModel = _ref2.getFromModel;

      _bindStorage(context, storage, mapToState, name);

      if (typeof getFromModel === 'function') {
        initialState = _objectSpread({}, initialState, {}, getFromModel(storage));
      }
    });
    return initialState;
  } else {
    var name = bindOptions.name,
        mapToState = bindOptions.mapToState,
        getFromModel = bindOptions.getFromModel;

    _bindStorage(context, storage, mapToState, name);

    if (typeof getFromModel === 'function') {
      return getFromModel(storage);
    } else {
      return {};
    }
  }
};

var bindModel = function bindModel(context, storage, mapModelToState, mapStateToModel) {
  if (!storage || !(storage instanceof _dataModel["default"]) || !context || typeof context.listenTo !== 'function' || typeof context.setState !== 'function' || typeof context.stopListening !== 'function') {
    return {};
  }

  registerContext(context);

  if (getStorage(context)) {
    unbindModel(context);
  }

  setStorage(context, storage);
  unsetDataMapper(context);

  if (typeof mapModelToState === 'function' && typeof mapStateToModel !== 'function') {
    window.console.error("Bind model exception. Function mapModelToState was supplied without mapStateToModel as second argument. To use function mapModelToState you should specify function mapStateToModel as second argument.");
  } // mapper thad used to get data from state and put it to model


  if (typeof mapStateToModel === 'function') {
    setDataMapper(context, mapStateToModel);
  } else if (typeof mapModelToState === 'string' || Array.isArray(mapModelToState)) {
    setDataMapper(context, mapModelToState);
  } else {
    var _process;

    if (((_process = process) === null || _process === void 0 ? void 0 : _process.env.NODE_ENV) !== 'production') {
      window.console.error("Bind model exception", 'invalid data mapper supplied to .bindModel. Expected String|Array, Supplied', (0, _typeof2["default"])(mapModelToState));
    }
  }

  try {
    return _bind(context, storage, mapModelToState);
  } catch (error) {
    var _process2;

    if (((_process2 = process) === null || _process2 === void 0 ? void 0 : _process2.env.NODE_ENV) !== 'production') {
      window.console.error("Bind model exception", error);
    }

    return {};
  }
}; // unbind


exports.bindModel = bindModel;

var unbindModel = function unbindModel(context) {
  var storage = getStorage(context);
  context.stopListening(storage);
  unsetStorage(context);
  unsetDataMapper(context);
  unregisterContext(context);
};

exports.unbindModel = unbindModel;

var transmitToModel = function transmitToModel(context, data) {
  var storage = getStorage(context),
      mapper = getDataMapper(context);

  if (context && storage && (0, _typeof2["default"])(data) === 'object' && !(0, _isEmpty["default"])(data)) {
    var attrs = _mapDataToModel(data, mapper);

    if (!(0, _isEmpty["default"])(attrs)) {
      storage.set(attrs, {
        __data_bind_source_context: context
      });
    }
  }
};

exports.transmitToModel = transmitToModel;